import { render } from "./FlowHistoryPanel.vue?vue&type=template&id=cf532026"
import script from "./FlowHistoryPanel.vue?vue&type=script&lang=ts"
export * from "./FlowHistoryPanel.vue?vue&type=script&lang=ts"

import "./FlowHistoryPanel.vue?vue&type=style&index=0&id=cf532026&lang=scss"
script.render = render

export default script